import React from "react";
import {
  Row,
  Col
} from "reactstrap"
import Caixa from './caixa'
import Grafico from './Grafico'
import './style.css'

const DashboardData1 = [
  {
    fonte: '/webgestor/api/vendas/principalGrafico.php',
    component: 'PizzaCard',
    title: 'Vendas Diárias',
    color: 'text-blue'
  },
  {
    fonte: '/webgestor/api/vendas/principalGrafico.php?tipo=mes',
    component: 'PizzaCard',
    title: 'Vendas Mensal',
    color: 'text-blue'
  },
  {
    fonte: '/webgestor/api/vendas/principalGraficoFP.php',
    component: 'PizzaCard',
    title: 'Vendas Farmacia Popular Diárias',
    color: 'text-success'
  },
  {
    fonte: '/webgestor/api/vendas/principalGraficoFP.php?tipo=mes',
    component: 'PizzaCard',
    title: 'Vendas Farmacia Popular Mensal',
    color: 'text-success'
  },
  // {
  //   fonte: '/webgestor/api/convenios/principalGrafico.php',
  //   component: 'PizzaCard',
  //   title: 'Convênios Diários (PBMs)',
  //   color: 'text-warning'
  //  },
  //  {
  //   fonte: '/webgestor/api/convenios/principalGrafico.php?tipo=mes',
  //   component: 'PizzaCard',
  //   title: 'Convênios Mensal (PBMs)',
  //   color: 'text-warning'
  //  },
  // {
  //   fonte: '/webgestor/api/vendas/ticketGrafico.php',
  //   component: 'PizzaCard',
  //   title: 'Ticket Médio',
  //   color: 'text-danger'
  // }
  // {
  //   fonte: '/webgestor/api/contasRecebidas/principalGrafico.php',
  //   component: 'PizzaCard',
  //   title: 'Recebimentos',
  //   color: 'text-success'
  // },
]

class Dashboard extends React.Component {

  constructor(props) {
    super(props)
    this.toggle = this.toggle.bind(this)
    this.state = { collapse: false }
  }

  toggle() {
    this.setState(state => ({ collapse: !state.collapse }))
  }

  render() {
    return (
      <>
        <div className="content pb-0">

          {/* LOJAS */}
          {/* <Lojas /> */}
          {/* LOJAS */}

          {/* VALORES */}
          <Caixa />
          {/* VALORES */}

          {/* GRÁFICOS */}
          <Row>
            {
              DashboardData1.map(grafico => {
                return (
                  <Col lg="6" sm="6" key={"col" + grafico.title}>
                    <Grafico                      
                      key={"grafico" + grafico.title}
                      title={grafico.title}
                      color={grafico.color}
                      fonte={grafico.fonte}
                      component={grafico.component}
                    />

                  </Col>
                )
              })
            }         
          </Row>        
          {/* GRÁFICOS */}
        </div>
      </>
    );
  }
}

export default Dashboard
